import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { MSATenantConfigSlice, TenantEditSlice } from '../../../../../reducers'
import {
  Box,
  Typography,
  Grid,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Skeleton
} from '@mui/material'
import { markFeaturesCheckbox, markUserFeatures } from './utils'

const UserFeatures = ({
  userFeatures,
  features,
  setFeatures,
  markAsDirty,
  disabled,
  loading,
  profile
}) => {
  const { sk } = profile
  const msaConfig = useSelector(MSATenantConfigSlice.selectors.selectTenantMSAConfig)
  const msaActive = useSelector(TenantEditSlice.selectors.msaActive)
  const userHasCompletedMSA = msaConfig.completedAssessments.includes(sk)
  const isMSADisabled = userHasCompletedMSA ||
    (msaConfig.seatsAvailable === 0 && !userFeatures['msa:access'])

  useEffect(() => {
    if (userFeatures) {
      setFeatures((features) => markUserFeatures(features, userFeatures))
    }
  }, [setFeatures, userFeatures])

  const handleCheckboxChange = (idx, event) => {
    setFeatures((state) =>
      markFeaturesCheckbox(state, idx, event.target.checked)
    )
    markAsDirty(true)
  }

  return (
    <Box>
      <Typography variant='h5' gutterBottom data-test='password-reset'>
        Products & Features Access Permission
      </Typography>
      <Grid container spacing={4}>
        <Grid item lg={6} xs={12}>
          <Typography variant='caption' color='GrayText'>
            Unchecking this option will revoke the user's access to the feature
          </Typography>
        </Grid>
        <Grid item lg={6} xs={12}>
          <Box>
            <FormGroup>
              {features.map((feature, index) =>
                loading ? (
                  <Skeleton
                    sx={{ marginBottom: 2 }}
                    width={200}
                    height={30}
                    key={feature.id}
                  />
                ) : (
                  (
                    feature.id === 'msa:access' ? (
                      msaActive && (
                        <Box display='flex' flexDirection='column'>
                          <FormControlLabel
                            key={feature.id}
                            control={
                              <Checkbox
                                checked={feature.checked}
                                disabled={feature.disabled || disabled || isMSADisabled}
                                onChange={(event) => handleCheckboxChange(index, event)}
                              />
                            }
                            label={feature.label}
                          />
                          <Typography variant='caption' color='textSecondary' data-test='permissions-msa-seats-total'>
                            Total Seats: {msaConfig.numberOfUsers}
                          </Typography>
                          <Typography variant='caption' color='textSecondary' data-test='permissions-msa-seats-available'>
                            Seats Available: {msaConfig.seatsAvailable}
                          </Typography>
                        </Box>
                      )
                    ) : (
                      <FormControlLabel
                        key={feature.id}
                        control={
                          <Checkbox
                            checked={feature.checked}
                            disabled={feature.disabled || disabled}
                            onChange={(event) => handleCheckboxChange(index, event)}
                          />
                        }
                        label={feature.label}
                      />
                    )
                  )
                )
              )}
            </FormGroup>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default UserFeatures
